import { FC, ReactNode } from 'react';
import styled from 'styled-components';
import { Container, Group, Text } from '@logz-ui/styleguide';

interface IStepperMenuItemProps {
  index: number;
  title: ReactNode;
  selected?: boolean;
  onClick?: () => void;
}

const StyledContainer = styled(props => <Container {...props} />)`
  transition: background-color 0.2s ease-in-out;
  cursor: pointer;
  :hover {
    background-color: ${({ theme }) => theme.colors.blue[100]};
  }
`;

export const StepperMenuItem: FC<IStepperMenuItemProps> = ({ index, title, selected, onClick }) => {
  return (
    <StyledContainer
      onClick={onClick}
      variant={selected ? 'secondary' : 'neutral'}
      p={3}
      borderRadius={'md'}
      width={'100%'}
    >
      <Group alignItems="center">
        <Text weight={600} size={12}>
          {index + 1}.
        </Text>
        {typeof title === 'string' ? (
          <Text weight={600} size={12}>
            {title}
          </Text>
        ) : (
          title
        )}
      </Group>
    </StyledContainer>
  );
};
